import { mapState, mapGetters } from 'vuex';

const LabelActions = {
    emits: ['delete-label', 'edit-label'],
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            labelsCan: 'labels/can',
        }),
        canDeleteLabel () {
            return this.labelsCan('delete');
        },
        canEditLabel () {
            return this.labelsCan('edit');
        },
        createLabelButtonText () {
            return this.$t('labelActions.Create new label');
        },
    },
    methods: {
        renderActions (label) {
            const actions = [];
            const createdByUsername = label.createdByUser.username;
            const isCreatedByUser = this.user.username === createdByUsername;
            if (this.canEditLabel || isCreatedByUser) {
                actions.push({
                    type: 'edit',
                    tooltip: this.$t('Edit'),
                    icon: {
                        type: 'edit',
                    },
                });
            }
            if (this.canDeleteLabel || isCreatedByUser) {
                actions.push({
                    type: 'delete',
                    tooltip: this.$t('Delete'),
                    icon: {
                        type: 'trash-2',
                    },
                });
            }

            return actions;
        },
        onDelete (label) {
            this.$emit('delete-label', label);
            this.close();
        },
        onEdit (label) {
            this.$emit('edit-label', label);
            this.close();
        },
    },
};

export default LabelActions;
